import { render, staticRenderFns } from "./33.vue?vue&type=template&id=19bd28bf&scoped=true&"
import script from "./33.vue?vue&type=script&lang=js&"
export * from "./33.vue?vue&type=script&lang=js&"
import style0 from "./33.vue?vue&type=style&index=0&id=19bd28bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bd28bf",
  null
  
)

export default component.exports